<template>
	<el-container class="container">
		<img class="logo" src='/img/导航.png' draggable="false"></img>
		<!-- 头部导航 -->
		<el-header class="header" style="height: 100px;">
			<el-menu :default-active="defaultactive" router class="el-menu-demo" mode="horizontal" @select="handleSelect" background-color="#7D3811" text-color="#fff" active-text-color="#fff">
				<el-menu-item index="index">首页</el-menu-item>
				<el-menu-item index="baseSituation">基地情况</el-menu-item>
				<el-menu-item index="regulations">规章制度</el-menu-item>
				<el-menu-item index="project">实训模块</el-menu-item>
				<el-menu-item index="teachers">师资队伍</el-menu-item>
				<el-menu-item index="resource">资源中心</el-menu-item>
				<el-menu-item index="cooperation">合作交流</el-menu-item>
				<el-menu-item index="material">申报材料</el-menu-item>
			</el-menu>
		</el-header>
		<!-- 嵌入内容 -->
		<router-view ref="subPage" @setDefaultactive='setDefaultactive'></router-view>
	</el-container>
</template>

<script>
	export default {
		data() {
			return {
				defaultactive: 'index',
				isInit: false
			}
		},
		methods: {
			// 跳转页面
			handleSelect(key, keyPath) {
				if (key) {

					if (this.$route.path == '/' + key) {
						this.$refs.subPage.init()
					}

					if (this.$route.fullPath != '/' + key) {
						this.$router.push(key)
						this.defaultactive = key
					}
				}
			},
			setDefaultactive(val) {

				if (val) {
					this.defaultactive = val
				} else {
					this.defaultactive = 'index'
				}
			}
		}
	}
</script>

<style lang="scss">
	.container {
		height: 100%;
		width: 100%;
		overflow-y: auto;
		overflow-x: hidden;

		.header {
			background-color: #7D3811;
			z-index: 999;

			.el-menu-demo {
				width: 1440px;
				margin: 0 auto;
				border-bottom: 0;

				.is-active {
					background-color: #6d2f0e !important;
				}
			}

			.el-menu-item {
				height: 100px;
				line-height: 100px;
				font-size: 20px;
				padding: 0 45px;
			}
		}
	}

	.main {
		padding: 0;
		background-color: #F2F2F2;
	}

	.el-footer {
		text-align: center;
		background-color: #000000;
		color: #fff;
		line-height: 25px;
		font-size: 14px;
		padding-top: 5px;
		min-width: 1280px;
	}
</style>